import React, { createContext, useContext, useRef } from "react";
import { openMatchmakingSocket } from "../services/websocket";


const WebSocketCtx = createContext(null);
export function useWebSocketCtx() { return useContext(WebSocketCtx); }


export function WebSocketProvider({ children }) {
const wsRef = useRef(null);


const connect = (category, handlers) => {
disconnect();
wsRef.current = openMatchmakingSocket(category, handlers);
return wsRef.current;
};


const send = (payload) => {
if (wsRef.current && wsRef.current.readyState === 1) {
wsRef.current.send(JSON.stringify(payload));
}
};


const disconnect = () => {
try { wsRef.current?.close(); } catch {} finally { wsRef.current = null; }
};


return (
<WebSocketCtx.Provider value={{ connect, send, disconnect }}>
{children}
</WebSocketCtx.Provider>
);
}